import React, { Component } from 'react';
import styled from 'styled-components';
import { Section, Row, Col, Button } from '../';
import PropTypes from 'prop-types';
import { formatMoney } from 'accounting';

const SectionConfirm = Section.extend`
  width: 360px;
  text-align: center;
  @media (max-width: 360px) {
    width: 300px;
  }
`;

const RowConfirm = Row.extend`
  width: 100%;
`;

export const Stat = styled.div`
  font-size: 16px;
  color: #4a4a4a;
  line-height: 23px;
  margin-top: 25px;
  margin-bottom: 15px;
`;

export const ImgConfirm = styled.img`
  margin-top: 30px;
`;

export default class LeadPackUpsellSuccess extends Component {
  static propTypes = {
    leadPackValue: PropTypes.number,
    remainingValue: PropTypes.number,
    onClickButton: PropTypes.func,
    logo: PropTypes.string
  };
  static defaultProps = {
    leadPackValue: 0,
    remainingValue: 0
  };

  render() {
    const { leadPackValue, remainingValue, onClickButton, logo } = this.props;
    return (
      <div>
        <SectionConfirm>
          <RowConfirm>
            <Col xs={12}>
              <ImgConfirm src={logo} alt="logo" width="59" height="60" />
            </Col>
          </RowConfirm>
          <RowConfirm>
            <Col xs={12}>
              <Stat>
                {formatMoney(leadPackValue)} Lead Pack purchased!<br />
                You have {formatMoney(remainingValue)} credit remaining.
              </Stat>
            </Col>
          </RowConfirm>
          <RowConfirm style={{ margin: 0 }}>
            <Col xs={1} />
            <Col xs={10}>
              <Button onClick={onClickButton} primary block style={{ marginBottom: 20 }}>
                Okay!
              </Button>
            </Col>
          </RowConfirm>
        </SectionConfirm>
      </div>
    );
  }
}
